<template>
        <div class="chat-container">
            <div class="chat-fixed" v-if="selected && selected.length > 0">
                    <p class="chat-fixed__text">Выбрано {{ selected.length }} сообщений</p>
                    <div class="chat-tools">
                        <div class="chat-tools__item" v-if="selected.length == 1 && yourMessages && !reply" @click="$emit('editMessage')">
                            <img src="@/assets/images/icons/edit.svg">
                        </div>
                        <div class="chat-tools__item" v-if="!edit" @click="$emit('setReply')">
                            <img src="@/assets/images/icons/reply.svg">
                        </div>
                        <div class="chat-tools__item" @click="deleteMessages()">
                            <img src="@/assets/images/icons/delete.svg">
                        </div>
                        <div class="chat-tools__item" v-if="selected" @click="$emit('clear')">
                            <img src="@/assets/images/icons/icon_close.svg" width="16">
                        </div>
                    </div>
                </div>

                <div class="chat-string" 
                    v-for="(message, index) in messages" 
                    :key="index" 
                    :class="{'no-padding': getPrevious(index - 1) == message.user.id, selected: isSelected(message)}"
                    @mousedown="select_start = true, mousemoveHandler(message)"
                    @mouseup="mousemoveHandler(message), select_start = false"
                    @mouseenter="mousemoveHandler(message)"
                >   
                    <div class="chat__date" v-if="todayHasNotMessages(index)">
                        <p>{{getDay(message.time) }}</p>
                    </div>
                        <transition name="slide" v-if="!message.type" >
                            <Message 
                                :message="message" 
                                :user="getUserData(message.user)" 
                                :users="users"
                                :showUser="showUser(index - 1, message)"
                                @click.native="selectString(message)" 
                            />
                        </transition>

                        <!-- Notifications -->
                        <div class="chat-notification" v-else-if="message.type === 'change_cover'">
                            <p>{{message.message}}.</p>
                        </div>
                        <div class="chat-notification" v-else-if="message.type === 'change_caption'">
                            <p>{{message.message}}.</p>
                        </div>
                        <div class="chat-notification" v-else-if="message.type === 'delete_user'">
                            <p>{{message.message}}.</p>
                        </div>
                        <div class="chat-notification" v-else-if="message.type === 'add_user'">
                            <p>{{message.message}}.</p>
                        </div>
                        <div class="chat-notification" v-else-if="message.type === 'join'">
                            <p>{{ message.user.firstname + ' ' + message.user.lastname }} присоединился к чату.</p>
                        </div>
                        <div class="chat-notification" v-else-if="message.type === 'leave'">
                            <p>{{ message.user.firstname + ' ' + message.user.lastname }} покинул чат.</p>
                        </div>
                        <div class="chat-notification" v-else-if="message.type === 'create'">
                            <p>{{ message.user.firstname + ' ' + message.user.lastname }} создал(а) чат.</p>
                        </div>
                        <div class="chat-notification" v-else-if="message.type === 'fromprivate'">
                            <p>{{ message.user.firstname + ' ' + message.user.lastname }} сделал(а) чат открытым‎.</p>
                        </div>
                        <div class="chat-notification" v-else-if="message.type === 'toprivate'">
                            <p>{{ message.user.firstname + ' ' + message.user.lastname }} сделал(а) чат приватным.</p>
                        </div>
                </div>
                <!-- ITEM -->

        </div>
</template>
<script>
export default {
    name: 'ChatMessages',
    props: {
        messages: {
            type: Array,
            required: true
        },
        users: {
            type: Array,
            required: true
        },
        selected: {
            type: Array,
            required: true
        },
        reply: {
            type: [Object, Boolean],
            required: false
        },
        edit: {
            type: [Object, Boolean],
            required: false
        }
    },
    components: {
        Message: () => import('./Message')
    },
    computed: {
        getUser() {
            return this.$store.getters.getAuthUser
        },
        yourMessages() {
            let result = true;
            if (this.selected && this.selected.length > 0) {
                this.selected.forEach(message => {
                    result = message.user.id == this.getUser.id ? true : false;
                })
            }
            return result
        }
    },
    methods: {
        mousemoveHandler(message) {
            this.select_start ? this.selectString(message) : ''
        },
        showUser(index, message) {
            return this.getPrevious(index) !== message.user.id
        },
        selectString(message) {
            this.$emit('selectString', message)
        },
        async deleteMessages() {
            let messages_id = [];
            this.selected.forEach(message => {
                messages_id.push(message.id)
            });
            await this.$socket.emit('delete_messages', {messages_id});
            this.selected = []
        },
        isSelected (message) {
            return this.selected.find(mess => mess.id === message.id)
        },
        
        getPrevious(index) {
            return this.messages[index] && !this.messages[index].type ? this.messages[index].user.id : null
        },
        getUserData(user) {
            return typeof user === 'string' ? JSON.parse(user) : user
        },
        todayHasNotMessages(index) {
            let current, previous, show = false;
            if (this.messages) {
                current = this.messages[index];
                previous = this.messages[index - 1];
                if (previous) {
                    let current_time = this.$moment(current.time).format('DD-MMM-YYYY');
                    let previous_time = this.$moment(previous.time).format('DD-MMM-YYYY');
                    show = current_time !== previous_time;
                } else {
                    show = true
                }
            }
            return show
        },
        getDay(time) {
            let year_current = this.$moment(time).format('YYYY'), year_now = this.$moment().format('YYYY');
            return year_now == year_current ? this.$moment(time).locale('ru').format('DD MMM') : this.$moment(time).locale('ru').format('DD MMM YYYY');
        },
    },
    mounted () {
        this.$emit('ready')
    }
}
</script>